module.exports = __webpack_public_path__ + "img/couples-055.fd5c4de7.jpg";